import {
  CREATE_GENERAL_INFO,
  GET_GENERAL_INFO,
  UPDATE_GENERAL_INFO,
} from "./types";
import { GeneralInfoType } from "@type/HRM/general-info";

// CREATE
export const createGeneralInfoRequest = (data: GeneralInfoType) => {
  return {
    type: CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const createGeneralInfoSuccess = (data: GeneralInfoType) => {
  return {
    type: CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const createGeneralInfoFailed = (err: any) => {
  return {
    type: CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_FAILED,
    payload: {
      err,
    },
  } as const;
};

//FETCH
export const getGeneralInfoRequest = (data: number | null) => {
  return {
    type: GET_GENERAL_INFO.GET_GENERAL_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const getGeneralInfoSuccess = (data: GeneralInfoType) => {
  return {
    type: GET_GENERAL_INFO.GET_GENERAL_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const getGeneralInfoFailed = () => {
  return {
    type: GET_GENERAL_INFO.GET_GENERAL_INFO_FAILED,
  } as const;
};

//UPDATE
export const updateGeneralInfoRequest = (data: GeneralInfoType) => {
  return {
    type: UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateGeneralInfoSuccess = (data: GeneralInfoType) => {
  return {
    type: UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateGeneralInfoFailed = (data: any) => {
  return {
    type: UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_FAILED,
    payload: { data },
  } as const;
};

export type GeneralInfoActions =
  | ReturnType<typeof createGeneralInfoRequest>
  | ReturnType<typeof createGeneralInfoSuccess>
  | ReturnType<typeof createGeneralInfoFailed>
  | ReturnType<typeof getGeneralInfoRequest>
  | ReturnType<typeof getGeneralInfoSuccess>
  | ReturnType<typeof getGeneralInfoFailed>
  | ReturnType<typeof updateGeneralInfoRequest>
  | ReturnType<typeof updateGeneralInfoSuccess>
  | ReturnType<typeof updateGeneralInfoFailed>;
